module.exports = __webpack_public_path__ + "static/img/pic3.3f48f16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case2/pic3.jpg
// module id = HnYB
// module chunks = 1